import React, { useEffect, useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { FilmIcon, SearchIcon, FilterIcon, CalendarIcon, ClockIcon, MapPinIcon, StarIcon, HeartIcon, BookmarkIcon, Share2Icon, PlayIcon, ChevronDownIcon, InfoIcon, TagIcon, ThumbsUpIcon, ThumbsDownIcon, UserIcon, CheckIcon, TicketIcon } from 'lucide-react';
const Movies = () => {
  const [activeTab, setActiveTab] = useState('nowShowing');
  const [activeFilter, setActiveFilter] = useState('all');
  const [linkCopied, setLinkCopied] = useState(false);
  const [selectedGenre, setSelectedGenre] = useState('all');
  const [selectedRating, setSelectedRating] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [shareDropdownOpen, setShareDropdownOpen] = useState<number | null>(null);
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    });
  };
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (shareDropdownOpen !== null) {
        const target = event.target as HTMLElement;
        if (!target.closest('.share-dropdown-container')) {
          setShareDropdownOpen(null);
        }
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [shareDropdownOpen]);
  const genres = [{
    id: 'all',
    name: 'All Genres'
  }, {
    id: 'action',
    name: 'Action'
  }, {
    id: 'comedy',
    name: 'Comedy'
  }, {
    id: 'drama',
    name: 'Drama'
  }, {
    id: 'scifi',
    name: 'Sci-Fi'
  }, {
    id: 'horror',
    name: 'Horror'
  }, {
    id: 'romance',
    name: 'Romance'
  }, {
    id: 'documentary',
    name: 'Documentary'
  }, {
    id: 'animation',
    name: 'Animation'
  }];
  const ratings = [{
    id: 'all',
    name: 'All Ratings'
  }, {
    id: '9+',
    name: '9+'
  }, {
    id: '8+',
    name: '8+'
  }, {
    id: '7+',
    name: '7+'
  }, {
    id: '6+',
    name: '6+'
  }, {
    id: '5+',
    name: '5+'
  }];
  const movies = [{
    id: '1',
    title: 'Dune: Part Two',
    genre: ['sci-fi', 'action', 'adventure'],
    releaseDate: 'March 1, 2024',
    duration: '166 min',
    imdbRating: '8.8',
    rottenTomatoes: '92%',
    image: 'https://m.media-amazon.com/images/M/MV5BODI0YjNhNjUtYjM0My00MTUwLWFlYTMtMWI2NGUzYjNjNGQzXkEyXkFqcGdeQXVyMDM2NDM2MQ@@._V1_.jpg',
    description: 'Paul Atreides unites with Chani and the Fremen while seeking revenge against the conspirators who destroyed his family.',
    director: 'Denis Villeneuve',
    cast: ['Timothée Chalamet', 'Zendaya', 'Rebecca Ferguson'],
    showings: [{
      time: '10:00 AM',
      theater: 'Century Cinemax - Junction Mall'
    }, {
      time: '1:30 PM',
      theater: 'Century Cinemax - Junction Mall'
    }, {
      time: '5:00 PM',
      theater: 'Century Cinemax - Junction Mall'
    }, {
      time: '8:30 PM',
      theater: 'Century Cinemax - Junction Mall'
    }]
  }, {
    id: '2',
    title: 'Kung Fu Panda 4',
    genre: ['animation', 'comedy', 'action'],
    releaseDate: 'March 8, 2024',
    duration: '94 min',
    imdbRating: '7.3',
    rottenTomatoes: '84%',
    image: 'https://m.media-amazon.com/images/M/MV5BYzI0YjYxY2UtNzRkNS00MmZhLTkzNzMtODk4Y2M3MmE4NGJkXkEyXkFqcGdeQXVyMTUzMTg2ODkz._V1_.jpg',
    description: 'Po is tapped to become the Spiritual Leader of the Valley of Peace, but needs to find and train a new Dragon Warrior before he can assume his new position.',
    director: 'Mike Mitchell',
    cast: ['Jack Black', 'Awkwafina', 'Viola Davis'],
    showings: [{
      time: '11:00 AM',
      theater: 'Anga Sky - Diamond Plaza'
    }, {
      time: '2:00 PM',
      theater: 'Anga Sky - Diamond Plaza'
    }, {
      time: '4:30 PM',
      theater: 'Anga Sky - Diamond Plaza'
    }]
  }, {
    id: '3',
    title: 'Bob Marley: One Love',
    genre: ['biography', 'drama', 'music'],
    releaseDate: 'February 14, 2024',
    duration: '104 min',
    imdbRating: '6.8',
    rottenTomatoes: '72%',
    image: 'https://m.media-amazon.com/images/M/MV5BZDc4MzVkZTctMzU3Ni00M2I1LTkzMjYtZTFkNmE0MjJmMDUwXkEyXkFqcGdeQXVyMTA3MDk2NDg2._V1_.jpg',
    description: 'A look at the life of legendary reggae musician Bob Marley.',
    director: 'Reinaldo Marcus Green',
    cast: ['Kingsley Ben-Adir', 'Lashana Lynch', 'James Norton'],
    showings: [{
      time: '12:15 PM',
      theater: 'IMAX - Garden City'
    }, {
      time: '3:45 PM',
      theater: 'IMAX - Garden City'
    }, {
      time: '7:00 PM',
      theater: 'IMAX - Garden City'
    }]
  }, {
    id: '4',
    title: 'Madame Web',
    genre: ['action', 'sci-fi', 'adventure'],
    releaseDate: 'February 14, 2024',
    duration: '116 min',
    imdbRating: '3.8',
    rottenTomatoes: '23%',
    image: 'https://m.media-amazon.com/images/M/MV5BYWJkY2Q4YmItZTAzZi00YzRiLWJlNmYtZGZlYzE5ZWYzY2EzXkEyXkFqcGdeQXVyMTUzMTg2ODkz._V1_.jpg',
    description: 'Cassandra Webb develops the power to see the future. Forced to confront revelations about her past, she forges a relationship with three young women bound for powerful destinies, if they can all survive a deadly present.',
    director: 'S.J. Clarkson',
    cast: ['Dakota Johnson', 'Sydney Sweeney', 'Isabela Merced'],
    showings: [{
      time: '1:00 PM',
      theater: 'Prestige Cinema - Prestige Plaza'
    }, {
      time: '4:15 PM',
      theater: 'Prestige Cinema - Prestige Plaza'
    }, {
      time: '7:30 PM',
      theater: 'Prestige Cinema - Prestige Plaza'
    }]
  }, {
    id: '5',
    title: 'Oppenheimer',
    genre: ['biography', 'drama', 'history'],
    releaseDate: 'July 21, 2023',
    duration: '180 min',
    imdbRating: '8.5',
    rottenTomatoes: '93%',
    image: 'https://m.media-amazon.com/images/M/MV5BMDBmYTZjNjUtN2M1MS00MTQ2LTk2ODgtNzc2M2QyZGE5NTVjXkEyXkFqcGdeQXVyNzAwMjU2MTY@._V1_.jpg',
    description: 'The story of American scientist J. Robert Oppenheimer and his role in the development of the atomic bomb.',
    director: 'Christopher Nolan',
    cast: ['Cillian Murphy', 'Emily Blunt', 'Matt Damon'],
    showings: [{
      time: '11:30 AM',
      theater: 'Century Cinemax - Garden City'
    }, {
      time: '3:00 PM',
      theater: 'Century Cinemax - Garden City'
    }, {
      time: '6:30 PM',
      theater: 'Century Cinemax - Garden City'
    }]
  }, {
    id: '6',
    title: 'The Beekeeper',
    genre: ['action', 'thriller'],
    releaseDate: 'January 12, 2024',
    duration: '105 min',
    imdbRating: '6.5',
    rottenTomatoes: '71%',
    image: 'https://m.media-amazon.com/images/M/MV5BOTJhZTUxNzMtZjQ5Mi00YmE1LWJjZGYtYzJhOGFkNGE5OTUzXkEyXkFqcGdeQXVyMTA3MDk2NDg2._V1_.jpg',
    description: "One man's brutal campaign for vengeance takes on national stakes after he is revealed to be a former operative of a powerful and clandestine organization known as Beekeepers.",
    director: 'David Ayer',
    cast: ['Jason Statham', 'Emmy Raver-Lampman', 'Josh Hutcherson'],
    showings: [{
      time: '2:30 PM',
      theater: 'Anga Diamond - Diamond Plaza'
    }, {
      time: '5:45 PM',
      theater: 'Anga Diamond - Diamond Plaza'
    }, {
      time: '9:00 PM',
      theater: 'Anga Diamond - Diamond Plaza'
    }]
  }];
  const filteredMovies = movies.filter(movie => {
    if (searchQuery && !movie.title.toLowerCase().includes(searchQuery.toLowerCase())) {
      return false;
    }
    if (selectedGenre !== 'all' && !movie.genre.includes(selectedGenre)) {
      return false;
    }
    if (selectedRating !== 'all') {
      const minimumRating = parseInt(selectedRating.replace('+', ''));
      if (parseFloat(movie.imdbRating) < minimumRating) {
        return false;
      }
    }
    return true;
  });
  const toggleShareDropdown = (movieId: string) => {
    setShareDropdownOpen(shareDropdownOpen === Number(movieId) ? null : Number(movieId));
  };
  const shareMovie = (movie: any, platform?: string) => {
    const message = `Check out ${movie.title} - IMDb: ${movie.imdbRating}, RT: ${movie.rottenTomatoes}`;
    if (platform) {
      let url = '';
      switch (platform) {
        case 'twitter':
          url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;
          window.open(url, '_blank');
          break;
        case 'facebook':
          url = `https://www.facebook.com/sharer/sharer.php?u=https://jointoday.co.ke/movies&quote=${encodeURIComponent(message)}`;
          window.open(url, '_blank');
          break;
        case 'whatsapp':
          url = `https://wa.me/?text=${encodeURIComponent(message)}`;
          window.open(url, '_blank');
          break;
      }
    } else {
      copyToClipboard(message);
    }
    setShareDropdownOpen(null);
  };
  return <div className="pb-16 w-full bg-white dark:bg-gray-900" data-id="element-2546">
      <div className="border-b border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 w-full" data-id="element-2547">
        <div className="max-w-4xl mx-auto p-4" data-id="element-2548">
          <h1 className="text-2xl font-bold mb-2 flex items-center dark:text-gray-200" data-id="element-2549">
            <FilmIcon className="w-6 h-6 mr-2" data-id="element-2550" />
            Movies
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4" data-id="element-2551">
            Discover and book tickets for the latest movies showing in Kenyan
            theaters
          </p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto p-4" data-id="element-2552">
        {/* Search and Filter */}
        <div className="mb-6" data-id="element-2553">
          <div className="relative mb-4" data-id="element-2554">
            <input type="text" placeholder="Search movies..." className="w-full p-3 pl-10 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-800 dark:text-gray-200" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2555" />
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-2556" />
          </div>
          <div className="flex overflow-x-auto space-x-2 pb-2 mb-4" data-id="element-2557">
            <button onClick={() => setActiveTab('nowShowing')} className={`px-3 py-1 border rounded-full whitespace-nowrap text-sm ${activeTab === 'nowShowing' ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'border-gray-300 dark:border-gray-600 dark:text-gray-200'}`} data-id="element-2558">
              Now Showing
            </button>
            <button onClick={() => setActiveTab('comingSoon')} className={`px-3 py-1 border rounded-full whitespace-nowrap text-sm ${activeTab === 'comingSoon' ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'border-gray-300 dark:border-gray-600 dark:text-gray-200'}`} data-id="element-2559">
              Coming Soon
            </button>
            <button onClick={() => setActiveTab('recommended')} className={`px-3 py-1 border rounded-full whitespace-nowrap text-sm ${activeTab === 'recommended' ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'border-gray-300 dark:border-gray-600 dark:text-gray-200'}`} data-id="element-2560">
              Recommended
            </button>
          </div>
          <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-2561">
            <div data-id="element-2562">
              <label className="block text-sm font-medium mb-1 dark:text-gray-300" data-id="element-2563">
                Genre
              </label>
              <select className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-800 dark:text-gray-200" value={selectedGenre} onChange={e => setSelectedGenre(e.target.value)} data-id="element-2564">
                {genres.map(genre => <option key={genre.id} value={genre.id} data-id="element-2565">
                    {genre.name}
                  </option>)}
              </select>
            </div>
            <div data-id="element-2566">
              <label className="block text-sm font-medium mb-1 dark:text-gray-300" data-id="element-2567">
                Rating
              </label>
              <select className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-800 dark:text-gray-200" value={selectedRating} onChange={e => setSelectedRating(e.target.value)} data-id="element-2568">
                {ratings.map(rating => <option key={rating.id} value={rating.id} data-id="element-2569">
                    {rating.name}
                  </option>)}
              </select>
            </div>
          </div>
        </div>
        {/* Movies Grid */}
        <div className="mb-6" data-id="element-2570">
          <div className="flex justify-between items-center mb-4" data-id="element-2571">
            <h2 className="text-lg font-medium dark:text-gray-200" data-id="element-2572">
              {activeTab === 'nowShowing' ? 'Now Showing' : activeTab === 'comingSoon' ? 'Coming Soon' : 'Recommended for You'}
            </h2>
            <div className="flex items-center text-sm text-gray-600 dark:text-gray-400" data-id="element-2573">
              <span data-id="element-2574">{filteredMovies.length} movies</span>
            </div>
          </div>
          {filteredMovies.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2575">
              {filteredMovies.map(movie => <div key={movie.id} className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden" data-id="element-2576">
                  <div className="md:flex" data-id="element-2577">
                    <div className="md:w-1/3 h-48 md:h-auto bg-gray-200 dark:bg-gray-700 relative" data-id="element-2578">
                      {movie.image ? <img src={movie.image} alt={movie.title} className="w-full h-full object-cover" data-id="element-2579" /> : <div className="w-full h-full flex items-center justify-center" data-id="element-2580">
                          <FilmIcon className="w-12 h-12 text-gray-400 dark:text-gray-500" data-id="element-2581" />
                        </div>}
                      <div className="absolute top-2 right-2 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 text-xs font-bold px-2 py-1 rounded" data-id="element-2582">
                        {movie.imdbRating}
                      </div>
                    </div>
                    <div className="p-4 md:w-2/3" data-id="element-2583">
                      <h3 className="font-bold text-lg mb-1 dark:text-gray-200" data-id="element-2584">
                        {movie.title}
                      </h3>
                      <div className="flex flex-wrap gap-2 mb-2" data-id="element-2585">
                        {movie.genre.map((g, index) => <span key={index} className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded dark:text-gray-200" data-id="element-2586">
                            {g.charAt(0).toUpperCase() + g.slice(1)}
                          </span>)}
                      </div>
                      <div className="flex items-center text-xs text-gray-600 dark:text-gray-400 mb-2" data-id="element-2587">
                        <CalendarIcon className="w-3 h-3 mr-1" data-id="element-2588" />
                        <span data-id="element-2589">{movie.releaseDate}</span>
                        <span className="mx-2" data-id="element-2590">•</span>
                        <ClockIcon className="w-3 h-3 mr-1" data-id="element-2591" />
                        <span data-id="element-2592">{movie.duration}</span>
                      </div>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-3 line-clamp-2" data-id="element-2593">
                        {movie.description}
                      </p>
                      <div className="flex justify-between items-center" data-id="element-2594">
                        <div className="flex space-x-2" data-id="element-2595">
                          <a href="#" className="text-xs bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-3 py-1 rounded-md flex items-center" data-id="element-2596">
                            <TicketIcon className="w-3 h-3 mr-1" data-id="element-2597" />
                            Book Tickets
                          </a>
                          <div className="relative share-dropdown-container" data-id="element-2598">
                            <button onClick={() => toggleShareDropdown(movie.id)} className="text-xs border border-gray-300 dark:border-gray-600 px-2 py-1 rounded-md dark:text-gray-200 flex items-center" data-id="element-2599">
                              <Share2Icon className="w-3 h-3 mr-1" data-id="element-2600" />
                              Share
                            </button>
                            {shareDropdownOpen === Number(movie.id) && <div className="absolute left-0 mt-1 w-36 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-lg z-10" data-id="element-2601">
                                <button onClick={() => shareMovie(movie, 'whatsapp')} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-2602">
                                  <span className="text-xs mr-2" data-id="element-2603">📱</span>
                                  WhatsApp
                                </button>
                                <button onClick={() => shareMovie(movie, 'twitter')} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-2604">
                                  <span className="text-xs mr-2" data-id="element-2605">🐦</span>
                                  Twitter
                                </button>
                                <button onClick={() => shareMovie(movie, 'facebook')} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-2606">
                                  <span className="text-xs mr-2" data-id="element-2607">👥</span>
                                  Facebook
                                </button>
                                <button onClick={() => shareMovie(movie)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-2608">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-2609">
                                    <rect width="14" height="14" x="8" y="8" rx="2" ry="2" data-id="element-2610" />
                                    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" data-id="element-2611" />
                                  </svg>
                                  Copy Link
                                </button>
                              </div>}
                          </div>
                        </div>
                        <div className="flex items-center" data-id="element-2612">
                          <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded mr-1 dark:text-gray-200" data-id="element-2613">
                            RT: {movie.rottenTomatoes}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div> : <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-8 text-center" data-id="element-2614">
              <FilmIcon className="w-12 h-12 mx-auto text-gray-400 dark:text-gray-500 mb-2" data-id="element-2615" />
              <p className="text-gray-600 dark:text-gray-400" data-id="element-2616">
                No movies found matching your criteria
              </p>
              <button onClick={() => {
            setSearchQuery('');
            setSelectedGenre('all');
            setSelectedRating('all');
          }} className="mt-3 text-sm text-gray-800 dark:text-gray-200 underline" data-id="element-2617">
                Clear filters
              </button>
            </div>}
        </div>
        {/* Theaters */}
        <div className="mb-6" data-id="element-2618">
          <h2 className="text-lg font-medium mb-3 dark:text-gray-200" data-id="element-2619">
            Popular Theaters
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2620">
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-2621">
              <h3 className="font-medium mb-1 dark:text-gray-200" data-id="element-2622">
                Century Cinemax - Junction Mall
              </h3>
              <div className="flex items-center text-xs text-gray-600 dark:text-gray-400 mb-2" data-id="element-2623">
                <MapPinIcon className="w-3 h-3 mr-1" data-id="element-2624" />
                <span data-id="element-2625">Ngong Road, Nairobi</span>
              </div>
              <div className="flex items-center text-xs mb-3" data-id="element-2626">
                <div className="flex items-center mr-3" data-id="element-2627">
                  <StarIcon className="w-3 h-3 text-gray-800 dark:text-gray-200 mr-1" data-id="element-2628" />
                  <span className="dark:text-gray-300" data-id="element-2629">4.7</span>
                </div>
                <span className="text-gray-500 dark:text-gray-400" data-id="element-2630">
                  5 screens
                </span>
              </div>
              <a href="#" className="text-xs border border-gray-300 dark:border-gray-600 rounded-md px-3 py-1 flex items-center w-max dark:text-gray-200" data-id="element-2631">
                View Showtimes
              </a>
            </div>
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-2632">
              <h3 className="font-medium mb-1 dark:text-gray-200" data-id="element-2633">
                IMAX - Garden City
              </h3>
              <div className="flex items-center text-xs text-gray-600 dark:text-gray-400 mb-2" data-id="element-2634">
                <MapPinIcon className="w-3 h-3 mr-1" data-id="element-2635" />
                <span data-id="element-2636">Thika Road, Nairobi</span>
              </div>
              <div className="flex items-center text-xs mb-3" data-id="element-2637">
                <div className="flex items-center mr-3" data-id="element-2638">
                  <StarIcon className="w-3 h-3 text-gray-800 dark:text-gray-200 mr-1" data-id="element-2639" />
                  <span className="dark:text-gray-300" data-id="element-2640">4.9</span>
                </div>
                <span className="text-gray-500 dark:text-gray-400" data-id="element-2641">
                  2 screens
                </span>
              </div>
              <a href="#" className="text-xs border border-gray-300 dark:border-gray-600 rounded-md px-3 py-1 flex items-center w-max dark:text-gray-200" data-id="element-2642">
                View Showtimes
              </a>
            </div>
          </div>
          <div className="mt-3 text-center" data-id="element-2643">
            <a href="#" className="text-sm text-gray-800 dark:text-gray-200 hover:underline" data-id="element-2644">
              View all theaters
            </a>
          </div>
        </div>
        {/* Movie News */}
        <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-2645">
          <h2 className="text-lg font-medium mb-3 dark:text-gray-200" data-id="element-2646">
            Movie News & Updates
          </h2>
          <div className="space-y-3" data-id="element-2647">
            <div className="flex items-start" data-id="element-2648">
              <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-md flex items-center justify-center mr-3" data-id="element-2649">
                <InfoIcon className="w-6 h-6 text-gray-500 dark:text-gray-400" data-id="element-2650" />
              </div>
              <div data-id="element-2651">
                <h3 className="text-sm font-medium dark:text-gray-200" data-id="element-2652">
                  New IMAX Theater Opening in Westlands
                </h3>
                <p className="text-xs text-gray-600 dark:text-gray-400" data-id="element-2653">
                  A new state-of-the-art IMAX theater will be opening next month
                  at Sarit Centre.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-2654">
              <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-md flex items-center justify-center mr-3" data-id="element-2655">
                <TicketIcon className="w-6 h-6 text-gray-500 dark:text-gray-400" data-id="element-2656" />
              </div>
              <div data-id="element-2657">
                <h3 className="text-sm font-medium dark:text-gray-200" data-id="element-2658">
                  Special Tuesday Discounts
                </h3>
                <p className="text-xs text-gray-600 dark:text-gray-400" data-id="element-2659">
                  Get 30% off all movie tickets every Tuesday at participating
                  theaters.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Copied to clipboard notification */}
        {linkCopied && <div className="fixed bottom-4 right-4 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-4 py-2 rounded-md flex items-center z-50" data-id="element-2660">
            <CheckIcon className="w-4 h-4 mr-2" data-id="element-2661" />
            <span data-id="element-2662">Copied to clipboard</span>
          </div>}
      </div>
    </div>;
};
export default Movies;